import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";
import "./sass/custom.css";
// import Dashboard from './modules/dashboard/Dashboard';
// import DashboardV2 from './modules/dashboardV2/Index';
// import PerformanceReport from './modules/dashboardV2/PerformanceReport';
import { Provider } from 'react-redux';
import { DashboardStore } from "./modules/dashboard/DashboardStore";
import HomeWrapper from "./HomeWrapper"; 

class App extends Component {
    render() {
        return (
            <Provider store={DashboardStore}>
                <Router>
                    <Routes>
                        {/* Single route with conditional logic */}
                        {/* <Route path="/" element={<Dashboard />} />
                        <Route path="/live-monitor" element={<DashboardV2 />} />
                        <Route path="/performance-report" element={<PerformanceReport />} />  */}
                        <Route path="/" element={<HomeWrapper />} />
                    </Routes>
                </Router>
            </Provider>
        )
    }
}

export default App;
